import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import { RouteGuard } from "./RouteGuide";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(RouteGuard);
export default router;
